// test2551
(2551 && 0);
